import Img from "../img";

export interface SocialLoginButtonsProps {
	onGoogleLogin: () => void | Promise<void>;
	onFacebookLogin: () => void | Promise<void>;
	onAppleLogin: () => void | Promise<void>;
}

/**
 * SocialLoginButtons Component
 *
 * Renders social login buttons for Google, Facebook, and Apple authentication
 *
 * @param onGoogleLogin - Callback for Google login
 * @param onFacebookLogin - Callback for Facebook login
 * @param onAppleLogin - Callback for Apple login
 */
export const SocialLoginButtons = ({
	onGoogleLogin,
	onFacebookLogin,
	onAppleLogin,
}: SocialLoginButtonsProps) => {
	return (
		<div className="social-signon">
			<div className="social-button-cont">
				<div
					onClick={onFacebookLogin}
					role="button"
					tabIndex={0}
					className="social-button facebook-login"
					data-testid="facebook-login-button"
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							void onFacebookLogin();
						}
					}}
				>
					<div className="svg">
						<Img src="/images/svg/fb-logo.svg" />
					</div>
				</div>
				<div
					onClick={onGoogleLogin}
					role="button"
					tabIndex={0}
					className="social-button google-login"
					data-testid="google-login-button"
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							void onGoogleLogin();
						}
					}}
				>
					<div className="svg">
						<Img src="/images/svg/google-logo.svg" />
					</div>
				</div>
				<div
					onClick={onAppleLogin}
					role="button"
					tabIndex={0}
					className="social-button apple-login"
					data-testid="apple-login-button"
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							void onAppleLogin();
						}
					}}
				>
					<div className="svg">
						<Img src="/images/svg/apple-logo.svg" />
					</div>
				</div>
			</div>
		</div>
	);
};
